var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('uc-modal', {
    ref: "forgotPasswordModalRef",
    attrs: {
      "closable": true,
      "is-full-screen": _vm.$vuetify.breakpoint.xsOnly,
      "persistent": true,
      "modal-card-props": {
        headerText: 'Forgot Your Password?',
        headerIcon: _vm.HELP.split('mdi-')[1],
        size: 'lg'
      }
    },
    on: {
      "click:close": function ($event) {
        return _vm.resetValues();
      }
    },
    scopedSlots: _vm._u([{
      key: "content",
      fn: function () {
        return [_c('div', {
          staticClass: "d-flex flex-1 flex-column align-start justify-start mx-4"
        }, [_c('uc-text', {
          staticClass: "mb-4",
          attrs: {
            "text": "Please enter the email or phone number associated to your account and we’ll send you an OTP to change your password",
            "type": "body",
            "size": 1,
            "bold": false
          }
        }), _c('uc-phone-input', {
          ref: "phoneOrEmailRef",
          staticClass: "d-flex fill-width",
          attrs: {
            "label": _vm.EMAIL_OR_PHONE_REQ,
            "error-messages": _vm.phoneOrEmailErrorMessage
          },
          on: {
            "blur": _vm.checkExists
          },
          model: {
            value: _vm.emailOrPhone,
            callback: function ($$v) {
              _vm.emailOrPhone = $$v;
            },
            expression: "emailOrPhone"
          }
        }), _c('uc-button', {
          ref: "submitBtn",
          class: 'mb-2',
          attrs: {
            "type": 'primary',
            "state": 'primary',
            "text": 'SEND CODE',
            "disabled": !_vm.validPhoneOrEmail
          },
          on: {
            "click": _vm.setOtpAction
          }
        })], 1)];
      },
      proxy: true
    }])
  });
};
var staticRenderFns = [];
export { render, staticRenderFns };